import type { FC } from "react";

import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { CheckboxIcon } from "@similarweb/ui-components";

import { ListItemSegment } from "pro-features/pages/segments/components/ListItems";
import type { IListItemSegment } from "pro-features/pages/segments/components/ListItems";

interface IListItemSegmentWithCheckbox extends IListItemSegment {
    isChecked: boolean;
}

const SELECTED_CLASS_NAME = "selected-list-item";

const { bluegrey } = colorsPalettes;

const Container = styled.div`
    .${SELECTED_CLASS_NAME} {
        background-color: ${bluegrey[100]};
    }
`;

export const ListItemSegmentWithCheckbox: FC<IListItemSegmentWithCheckbox> = (props) => {
    const { isChecked, ...listItemSegmentProps } = props;
    const { isDisabled } = listItemSegmentProps;
    const customRenderData = (
        <CheckboxIcon
            selected={isChecked}
            disabled={isDisabled}
        />
    );

    return (
        <Container>
            <ListItemSegment
                {...listItemSegmentProps}
                customRenderData={customRenderData}
                className={isChecked ? SELECTED_CLASS_NAME : undefined}
            />
        </Container>
    );
};
